export default {
    currentUser: state => state.user.currentUser,
    token: state => state.user.token,
    isLoggIn: state => state.user.isLoggIn
}
